import React from 'react'
import yowant from '../../../../../imges/intro/brand-all.png'
import './index.less'

export default function() {
  return (
    <div className='pc-cooperative-brand-wrapper'>
      <div className='pc-cooperative-brand-wrapper-title'>
        合作品牌
      </div>
      <img src={yowant} alt="合作品牌" className='brand-img' />
    </div>
  )
}
